import { browser } from '$app/environment';
import type { Address } from '$types/address';

/**
 * Use this method in authenticated places.
 * If you expect null value, use localStorage directly.
 */
export const getPayAddress = () => {
  if (!browser) {
    return '0x0';
  }

  const address = localStorage.getItem('payAddress');

  return address as Address;
};
